import React from 'react'
import PropTypes from 'prop-types'

/**
 * Generic SceneObject component for interactive elements in the game
 * This component provides a base for clickable scene objects like doors, buttons, etc.
 */
const SceneObject = ({
  children,
  onClick,
  className = '',
  style = {},
  disabled = false,
  ...otherProps
}) => {
  const handleClick = (e) => {
    if (!disabled && onClick) {
      onClick(e)
    }
  }

  const baseClassName = `scene-object ${className} ${disabled ? 'disabled' : ''}`

  return (
    <div
      className={baseClassName}
      style={style}
      onClick={handleClick}
      role="button"
      tabIndex={disabled ? -1 : 0}
      onKeyPress={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
          handleClick(e)
        }
      }}
      {...otherProps}
    >
      {children}
    </div>
  )
}

SceneObject.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
}

export default SceneObject